var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.form
    ? _c(
        "div",
        { staticClass: "vgs-form", class: "variant--" + _vm.variant },
        [
          _vm.variant === "default"
            ? [
                _c(
                  "div",
                  { staticClass: "flex-grid-1-col gutter-md" },
                  [
                    _c(
                      "vgs-input",
                      _vm._b(
                        { on: { "fire-vgs-event": _vm.vgsEventTag } },
                        "vgs-input",
                        {
                          fieldClass: _vm.fieldClass,
                          fieldName: "card-holder",
                          fieldLabel: _vm.cardHolder,
                          haveBeenSubmited: _vm.haveBeenSubmited,
                          form: _vm.form,
                          css: _vm.isRtl ? _vm.cssRtl : _vm.css,
                          options: {
                            type: "text",
                            name: "CardHolderName",
                            ariaLabel: _vm.cardHolder,
                            placeholder: "",
                            validations: ["required"],
                          },
                        },
                        false
                      )
                    ),
                    _vm._v(" "),
                    _c(
                      "vgs-input",
                      _vm._b(
                        { on: { "fire-vgs-event": _vm.vgsEventTag } },
                        "vgs-input",
                        {
                          fieldClass: _vm.fieldClass,
                          fieldName: "card-number",
                          fieldLabel: _vm.cardNumberField,
                          haveBeenSubmited: _vm.haveBeenSubmited,
                          form: _vm.form,
                          css: _vm.isRtl ? _vm.cssRtl : _vm.css,
                          options: {
                            type: "card-number",
                            name: "CardNumber",
                            ariaLabel: _vm.cardNumberField,
                            successColor: "#4F8A10",
                            errorColor: "#D8000C",
                            placeholder: "",
                            showCardIcon: {
                              right: _vm.isRtl ? "" : "16px",
                              left: _vm.isRtl ? "16px" : "",
                            },
                            validations: ["required", "validCardNumber"],
                            autoComplete: "cc-number",
                          },
                        },
                        false
                      )
                    ),
                    _vm._v(" "),
                    _c(
                      "vgs-input",
                      _vm._b(
                        { on: { "fire-vgs-event": _vm.vgsEventTag } },
                        "vgs-input",
                        {
                          fieldClass: _vm.fieldClass,
                          fieldName: "card-exp",
                          fieldLabel: _vm.expDateField,
                          haveBeenSubmited: _vm.haveBeenSubmited,
                          form: _vm.form,
                          css: _vm.isRtl ? _vm.cssRtl : _vm.css,
                          options: {
                            type: "card-expiration-date",
                            name: "CardExpirateDate",
                            ariaLabel: _vm.expDateField,
                            successColor: "#4F8A10",
                            errorColor: "#D8000C",
                            placeholder: "",
                            yearLength: "2",
                            validations: [
                              "required",
                              "validCardExpirationDate",
                            ],
                            autoComplete: "cc-exp",
                          },
                        },
                        false
                      )
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.variant === "modify"
            ? [
                _c(
                  "div",
                  { staticClass: "flex-grid-1-col gutter-md" },
                  [
                    _c(
                      "vgs-input",
                      _vm._b(
                        { on: { "fire-vgs-event": _vm.vgsEventTag } },
                        "vgs-input",
                        {
                          fieldClass: _vm.fieldClass,
                          fieldName: "card-number",
                          fieldLabel: _vm.cardNumberField,
                          haveBeenSubmited: _vm.haveBeenSubmited,
                          form: _vm.form,
                          css: Object.assign(
                            {},
                            _vm.isRtl ? _vm.cssRtl : _vm.css,
                            {
                              "padding-left": _vm.isRtl ? "" : "55px",
                              "padding-right": _vm.isRtl ? "55px" : "",
                            }
                          ),
                          options: {
                            type: "card-number",
                            name: "CardNumber",
                            ariaLabel: _vm.cardNumberField,
                            successColor: "#4F8A10",
                            errorColor: "#D8000C",
                            placeholder: "",
                            showCardIcon: {
                              left: _vm.isRtl ? "" : "16px",
                              right: _vm.isRtl ? "16px" : "",
                            },
                            validations: ["required", "validCardNumber"],
                            autoComplete: "cc-number",
                          },
                        },
                        false
                      )
                    ),
                    _vm._v(" "),
                    _c(
                      "vgs-input",
                      _vm._b(
                        { on: { "fire-vgs-event": _vm.vgsEventTag } },
                        "vgs-input",
                        {
                          fieldClass: _vm.fieldClass,
                          fieldName: "card-exp",
                          fieldLabel: _vm.expDateField,
                          haveBeenSubmited: _vm.haveBeenSubmited,
                          form: _vm.form,
                          css: _vm.isRtl ? _vm.cssRtl : _vm.css,
                          options: {
                            type: "card-expiration-date",
                            name: "CardExpirateDate",
                            ariaLabel: _vm.expDateField,
                            successColor: "#4F8A10",
                            errorColor: "#D8000C",
                            placeholder: "",
                            yearLength: "2",
                            validations: [
                              "required",
                              "validCardExpirationDate",
                            ],
                            autoComplete: "cc-exp",
                          },
                        },
                        false
                      )
                    ),
                    _vm._v(" "),
                    _c(
                      "vgs-input",
                      _vm._b(
                        { on: { "fire-vgs-event": _vm.vgsEventTag } },
                        "vgs-input",
                        {
                          fieldClass: _vm.fieldClass,
                          fieldName: "card-holder",
                          fieldLabel: _vm.cardHolder,
                          haveBeenSubmited: _vm.haveBeenSubmited,
                          form: _vm.form,
                          css: _vm.isRtl ? _vm.cssRtl : _vm.css,
                          options: {
                            type: "text",
                            name: "CardHolderName",
                            ariaLabel: _vm.cardHolder,
                            placeholder: "",
                            validations: ["required"],
                          },
                        },
                        false
                      )
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }